// src/assets/standard-actions-override.js
//
// Configure window.Shopify.actions (injecté automatiquement par Shopify sur tout
// storefront Liquid) pour que les écritures panier venant des apps externes
// passent par l'UI du thème (mini-cart) au lieu de recharger la page.
//
// Ce fichier est chargé en <head> AVANT {{ content_for_header }} afin de
// s'exécuter avant le code des apps. Il est volontairement en JS classique (pas
// de module) et ne dépend pas du bundle Vite : il se contente de configurer les
// actions. Le rafraîchissement effectif du mini-cart est fait côté bundle, qui
// écoute les events standard shopify:cart:* (voir cart-external-sync.js).

(function () {
  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function init() {
    var actions = window.Shopify && window.Shopify.actions;
    if (!actions) return;

    // updateCart : on définit uniquement eventTarget (sans handler custom).
    // Effet (doc Shopify) : le handler par défaut (Storefront API) s'exécute, le
    // rechargement de page est ignoré, et les events standard sont dispatchés
    // depuis eventTarget -> notre <cart-drawer>, où le thème les écoute.
    if (
      actions.updateCart &&
      typeof actions.updateCart.configure === "function"
    ) {
      actions.updateCart.configure({
        eventTarget: function () {
          return getCartDrawer() || document.documentElement;
        },
      });
    }

    // openCart : ouvre le drawer du thème plutôt que le comportement par défaut.
    if (actions.openCart && typeof actions.openCart.configure === "function") {
      actions.openCart.configure({
        handler: function () {
          var drawer = getCartDrawer();
          if (drawer) {
            drawer.open = true;
          } else {
            var routes = window.themeVariables && window.themeVariables.routes;
            window.location.href = (routes && routes.cartUrl) || "/cart";
          }
        },
      });
    }

    // getCart n'est pas configurable (le configurer lève un TypeError).
  }

  if (window.Shopify && window.Shopify.actions) {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  }
})();
